// import { ThunkAction } from 'redux-thunk';
// import { RootState } from '..';
// import { newsDataAction } from './types';
import { postContactDataAsync } from './actions';
import { postContact } from '../../api/api';
import createAsyncThunk from '../../lib/createAsyncThunk';

export const postContactDataThunk = createAsyncThunk(postContactDataAsync, postContact)